import { render, staticRenderFns } from "./AreaEmergencyManage.vue?vue&type=template&id=c55d152c&scoped=true&"
import script from "./AreaEmergencyManage.vue?vue&type=script&lang=js&"
export * from "./AreaEmergencyManage.vue?vue&type=script&lang=js&"
import style0 from "./AreaEmergencyManage.vue?vue&type=style&index=0&id=c55d152c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55d152c",
  null
  
)

export default component.exports